var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4688 48.75C27.8125 42.4805 40 27.2852 40 18.75C40 8.39844 31.0417 0 20 0C8.95833 0 0 8.39844 0 18.75C0 27.2852 12.1875 42.4805 17.5312 48.75C18.8125 50.2441 21.1875 50.2441 22.4688 48.75ZM20 12.5C21.7681 12.5 23.4638 13.1585 24.714 14.3306C25.9643 15.5027 26.6667 17.0924 26.6667 18.75C26.6667 20.4076 25.9643 21.9973 24.714 23.1694C23.4638 24.3415 21.7681 25 20 25C18.2319 25 16.5362 24.3415 15.286 23.1694C14.0357 21.9973 13.3333 20.4076 13.3333 18.75C13.3333 17.0924 14.0357 15.5027 15.286 14.3306C16.5362 13.1585 18.2319 12.5 20 12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.727b3c94f10fea96c3772d24beb47833.svg";
export { ForwardRef as ReactComponent };